import { render, staticRenderFns } from "./type-usage-field.vue?vue&type=template&id=3b6e51f9&"
import script from "./type-usage-field.vue?vue&type=script&lang=js&"
export * from "./type-usage-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports